<template>
  <list-expansion
    v-model="obj"
    :components="customComponents"
    :disabled="loading"
    @save-required="handleSaveRequired"
  />
</template>

<script>
import ListExpansion from "@/view/content/fragments/listExpansion.vue";
import { mapState } from "vuex";

export default {
  name: "qrShopManager",

  components: { ListExpansion },

  props: {
    value: Object,
    qrId: [Number, String],
    domain: String,
    loading: Boolean,
  },

  data: () => ({
    obj: {
      cart: {
        fieldFilters: ["table_booking_ability"],
        online_pay: 1,
        card_pay: 1,
        send_by_courier: 1,
        send_by_post: 0,
        in_place: 1,
        table_booking_ability: 1,
        pay_in_person_place: 1,
        free_delivery: 0,
        min_order_cart: 500000,
        max_product_in_order: 30,
        max_order_by_person: 3,
        preparation_time: 30,
        delivery_time: 60,
        send_by_courier_price: 0,
        vat: 10,
      },
      gateways: {
        driver: "default",
      },
      reservation: [],
      notice: {
        phones: [{ number: "", id: null }],
      },
    },
  }),

  // mounted() {
  //   if (!['qr.menu'].includes(this.$route.name)) {
  //     this.fetchSettings()
  //     this.fetchTables()
  //   }
  // },

  computed: {
    ...mapState("localstorage", ["createQrID", "qrType"]),
    customComponents() {
      if (this.$i18n.locale === "fa") {
        return [
          {
            name: "manageGateways",
            value: "",
            title: this.$t("COMPONENTS.QR_SHOP_MANAGER.PAYMENT_METHODS"),
            subtitle: "",
            icon: "credit-card-settings-outline",
            model: "gateways",
          },
          {
            name: "orderNotices",
            value: "",
            title: this.$t("COMPONENTS.QR_SHOP_MANAGER.ORDER_NOTIFICATIONS"),
            subtitle: "",
            icon: "bell-outline",
            model: "notice",
          },
          {
            name: "manageDiscounts",
            value: "",
            title: this.$t("COMPONENTS.QR_SHOP_MANAGER.DISCOUNT_CODE"),
            subtitle: "",
            icon: "sale-outline",
            model: "discounts",
          },
          !this.obj.cart.fieldFilters.includes("manageCart") && {
            name: "manageCart",
            value: "",
            title: this.$t("COMPONENTS.QR_SHOP_MANAGER.CART"),
            subtitle: "",
            icon: "store-cog-outline",
            model: "cart",
          },
          this.obj.cart.table_booking_ability && {
            name: "manageTableReservation",
            value: "",
            title: this.$t("COMPONENTS.QR_SHOP_MANAGER.TABLE_MANAGEMENT"),
            subtitle: "",
            icon: "table-chair",
            model: "reservation",
          },
        ].filter((item) => !!item);
      } else {
        return [
          {
            name: "manageDiscounts",
            value: "",
            title: this.$t("COMPONENTS.QR_SHOP_MANAGER.DISCOUNT_CODE"),
            subtitle: "",
            icon: "sale-outline",
            model: "discounts",
          },
          !this.obj.cart.fieldFilters.includes("manageCart") && {
            name: "manageCart",
            value: "",
            title: this.$t("COMPONENTS.QR_SHOP_MANAGER.CART"),
            subtitle: "",
            icon: "store-cog-outline",
            model: "cart",
          },
          this.obj.cart.table_booking_ability && {
            name: "manageTableReservation",
            value: "",
            title: this.$t("COMPONENTS.QR_SHOP_MANAGER.TABLE_MANAGEMENT"),
            subtitle: "",
            icon: "table-chair",
            model: "reservation",
          },
        ].filter((item) => !!item);
      }
    },
    computedLoading: {
      get() {
        return this.loading;
      },
      set(val) {
        this.$emit("update:loading", val);
      },
    },
  },
  watch: {
    "$i18n.locale": {
      handler() {
        this.$forceUpdate();
      },
      immediate: true,
      deep: true,
    },
  },

  methods: {
  handleSaveRequired() {
    this.$emit("save-required");
  },
    fetchSettings() {
      this.computedLoading = true;

      this.$api
        .get(`/v1/testQr/setting/${this.createQrID}`)
        .then(({ data }) => {
          let cart = {
            ...data.data,
            fieldFilters: [],
          };
          this.handleQrType();
          this.obj.cart = cart;
        })
        .catch(({ response }) =>
          console.log("failed to get qr settings: ", response),
        )
        .finally(() => (this.computedLoading = false));
    },
    fetchTables() {
      this.computedLoading = true;

      this.$api
        .get(`/v1/testQr/table/list/${this.createQrID}`)
        .then(({ data }) => {
          this.obj.reservation = data.data.map((item) => {
            return {
              ...item,
              qr_id: this.createQrID,
            };
          });
        })
        .catch(({ response }) =>
          console.log("failed to get qr settings: ", response),
        )
        .finally(() => (this.computedLoading = false));
    },
    fetchNumbers() {
      this.computedLoading = true;

      this.$api
        .get("/v1/testQr/QrCodeNumber", {
          params: {
            qr_id: this.createQrID,
          },
        })
        .then(
          ({ data }) =>
            (this.obj.notice.phones[0] = {
              number: data?.data[0]?.number,
              id: data?.data[0]?.id,
            }),
        )
        .finally(() => (this.computedLoading = false));
    },
    setCartSetting() {
      return new Promise((resolve, reject) => {
        this.errors = {};
        let obj = this.obj.cart;
        obj.qr_code_id = this.createQrID || 1;

        this.$api
          .post("/v1/testQr/setting", obj)
          .then((data) => {
            resolve("resolved");
          })
          .catch(({ response }) => {
            if (
              !!response?.data?.errors &&
              !!Object.keys(response.data.errors).length
            )
              this.$toast.error(this.$t("COMPONENTS.ERRORS.INVALID_INPUT"));
            else
              this.$toast.error(
                this.$t("COMPONENTS.ERRORS.CART_SETTINGS_FAILED"),
              );
            reject("rejected");
          });
      });
    },
    setTableReservation() {
      return new Promise((resolve, reject) => {
        this.errors = {};
        let obj = this.obj.reservation;
        // obj.qr_code_id = this.createQrID || 1

        this.$api
          .post("/v1/testQr/table", obj)
          .then((data) => {
            resolve("resolved");
          })
          .catch(({ response }) => {
            if (
              !!response?.data?.errors &&
              !!Object.keys(response.data.errors).length
            )
              this.$toast.error(this.$t("COMPONENTS.ERRORS.INVALID_INPUT"));
            else
              this.$toast.error(
                this.$t("COMPONENTS.ERRORS.CART_SETTINGS_FAILED"),
              );

            reject("rejected");
          });
      });
    },
    setShopNotice() {
      let number = this.obj.notice.phones[0]?.number;
      let id = this.obj.notice.phones[0]?.id;
      if (!number) return;

      return new Promise((resolve, reject) => {
        this.errors = {};

        this.$api
          .post("/v1/testQr/QrCodeNumber", {
            // qr_code_number_id: this.createQrID,
            number: number,
            qr_code_number_id: id,
            qr_id: this.createQrID,
          })
          .then((data) => {
            resolve("resolved");
          })
          .catch(({ response }) => {
            if (
              !!response?.data?.errors &&
              !!Object.keys(response.data.errors).length
            )
              this.$toast.error(this.$t("COMPONENTS.ERRORS.INVALID_INPUT"));
            else
              this.$toast.error(
                this.$t("COMPONENTS.ERRORS.CART_SETTINGS_FAILED"),
              );
            reject("rejected");
          });
      });
    },
    handleQrType() {
      if (
        ["bshop", "appointment", "commericial"].includes(
          this.qrType?.toLowerCase(),
        )
      ) {
        this.obj.cart.fieldFilters = ["table_booking_ability"];
        this.obj.cart.table_booking_ability = 0;
      }

      if (["commericial"].includes(this.qrType?.toLowerCase())) {
        this.obj.cart.fieldFilters.push("manageCart");
      }
    },
  },
};
</script>

<style scoped></style>
